(async () => {
    class AnnouncementBar extends HTMLElement {
        constructor() {
            super();
            document.body.classList.add("announcement-bar-is-visible");
            this.closeButton = this.querySelector("[data-announcement-bar-close]");
            this.swiperElement = this.querySelector("[data-swiper-announcement-bar]");
            this.swiperOptions = {
                loop: true,
                autoplay: true,
                slidesPerView: 1,
                direction: "horizontal"
            };
            if (sessionStorage.getItem("hide-announcement-bar") === "true") {
                this.classList.add("hidden");
                document.body.classList.remove("announcement-bar-is-visible");
                document.querySelector('.shopify-section-new-header').classList.add('announcement--hide');

                if(document.querySelector('.shopify-section').classList.contains('sticky_easter-announcement-bar')) {
                    document.querySelector(`.shopify-section-new-header`).classList.add('sticky_header');
                    document.querySelector(`.shopify-section-new-header`).style.setProperty("--viewport-stickty-top", `${document.querySelector('.easter-announcement-bar').clientHeight}px`);  
                }

                if(document.querySelector('.shopify-section-new-announcement-bar') != null) {
                    document.querySelector(`.shopify-section-new-header`).style.setProperty("--viewport-stickty-top", `${document.querySelector('.shopify-section-new-announcement-bar').clientHeight}px`);  
                }

            } else {
                this.classList.remove("hidden");
                document.body.classList.add("announcement-bar-is-visible")
            }
            this.closeButton?.addEventListener("click", (() => {
                this.classList.add("hidden");
                sessionStorage.setItem("hide-announcement-bar", true);
                document.body.classList.remove("announcement-bar-is-visible");
                document.querySelector('.shopify-section-new-header').classList.add('announcement--hide');

            }));
            this.init()
        }
        init() {
            this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
            if (Shopify.designMode && this.swiperInstance) {
                const sectionSettings = JSON.parse(this.closest("[data-shopify-editor-section]").dataset.shopifyEditorSection);
                window.addEventListener("shopify:section:load", (() => {
                    this.swiperInstance.update()
                }));
                window.addEventListener("shopify:block:select", (event => {
                    if (event.detail.sectionId === sectionSettings.id) {
                        this.swiperInstance.update();
                        this.handleThemeEditorEvents(event)
                    }
                }))
            }
        }
        handleThemeEditorEvents(event) {
            this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1)
        }
    }
    window.AnnouncementBar = AnnouncementBar;
    customElements.define("announcement-bar", AnnouncementBar)
})();
//# sourceMappingURL=announcement-bar.js.map